module.exports = __webpack_public_path__ + "static/konto-bankowe-267ec96eba94f5c8cbb9ace5e8f66fb3.jpg";